/** Pill de status do playbook (Ativo / Rascunho / Descontinuado). */

import { statusLabel, statusPillModifier } from './playbook-labels';

import type { PlaybookStatus } from './types';

export function PlaybookStatusPill({ status }: { status: PlaybookStatus }): JSX.Element {
  return (
    <span className={`pb-status-pill pb-status-pill--${statusPillModifier(status)}`}>
      <span className="pb-status-pill__dot" aria-hidden />
      {statusLabel(status)}
    </span>
  );
}
